import { Search, X } from 'lucide-react';

const STATUS_FILTERS = [
  { value: 'All', label: 'All' },
  { value: 'VERIFIED', label: 'Verified' },
  { value: 'PENDING', label: 'Not verified' },
] as const;

type ClientsFilterBarProps = {
  search: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusChange: (value: string) => void;
  hasFilters: boolean;
  onClearFilters: () => void;
};

export function ClientsFilterBar({
  search,
  onSearchChange,
  statusFilter,
  onStatusChange,
  hasFilters,
  onClearFilters,
}: ClientsFilterBarProps) {
  return (
    <div className="camp-fade-up flex flex-col gap-3 rounded-2xl border border-[var(--dash-line)] bg-white p-4 shadow-[0_10px_28px_-22px_rgba(16,38,73,0.35)] sm:flex-row sm:items-center">
      <div className="relative flex-1 md:max-w-sm">
        <Search className="pointer-events-none absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-[var(--dash-muted)]" />
        <input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search name, email, phone"
          className="w-full rounded-xl border border-[var(--dash-line)] bg-[var(--dash-soft)] py-2.5 pr-10 pl-10 text-sm outline-none transition focus:border-[var(--dash-brand)] focus:bg-white focus:ring-2 focus:ring-[var(--dash-brand)]/15"
        />
        {search ? (
          <button
            type="button"
            onClick={() => onSearchChange('')}
            className="absolute top-1/2 right-2.5 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full bg-[rgba(15,27,45,0.08)] text-[var(--dash-muted)]"
            aria-label="Clear search"
          >
            <X className="h-3.5 w-3.5" strokeWidth={2.5} />
          </button>
        ) : null}
      </div>

      <div className="flex flex-wrap gap-2">
        {STATUS_FILTERS.map((opt) => {
          const active = statusFilter === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onStatusChange(opt.value)}
              className={`rounded-full px-3 py-1.5 text-xs font-semibold transition ${
                active
                  ? 'bg-[var(--dash-brand)] text-white'
                  : 'bg-[var(--dash-soft)] text-[var(--dash-muted)] hover:text-[var(--dash-ink)]'
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>

      {hasFilters ? (
        <button
          type="button"
          onClick={onClearFilters}
          className="text-xs font-semibold text-red-500 hover:underline sm:ml-auto"
        >
          Clear all
        </button>
      ) : null}
    </div>
  );
}
